define('root/app_store/Podio.UI.AppStore.Permalink',['require','jquery','jquery.rating','root/Podio.Comments','lib/Podio.Transport','lib/Podio.Event.UI','lib/Podio.Event'],function(require) {

  var $ = require('jquery');
  require('jquery.rating');

  var comments = require('root/Podio.Comments');
  var transport = require('lib/Podio.Transport');
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');

  function onDomReady() {
    $('.your-rating select').rating();
    comments.setupCommentBox();
  }

  function onFivestarClicked(elmTarget, e) {
    if (elmTarget.val()) {
      transport.postJSON(elmTarget.data('url') + '/' + elmTarget.val(), {});
    }
    else {
      transport.deleteJSON(elmTarget.data('url'), {});
    }
  }

  // Init
  podioEvent.bind(podioEvent.Types.init, onDomReady);
  eventUI.bind('change', '#wrapper.app-store .your-rating select', onFivestarClicked);

});



